import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Header } from '@/components/Header'
import { LoadingComponent } from '@/components/LoadingComponent'
import { LoginComponent } from '@/components/LoginComponent'
import { AuthProvider } from '@/contexts/AuthContext'
import { useAuth } from '@/hooks/useAuth'
import { BookedOut } from '@/pages/BookedOut'
import { Home } from '@/pages/Home'
import { Friends } from '@/pages/Friends'
import { MoveBook } from '@/pages/MoveBook'

const AppContent = () => {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingComponent />
  }

  if (!user) {
    return <LoginComponent />
  }

  return (
    <>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/move-book' element={<MoveBook />} />
        <Route path='/booked-out' element={<BookedOut />} />
        <Route path='/friends' element={<Friends />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </>
  )
}

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <AppContent />
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  )
}

export default App
